module.exports = __webpack_public_path__ + "static/media/zhongniuhushan1.cb9d6164.jpeg";